import LegalPage from "@/components/site/LegalPage";
import { breadcrumbLd } from "@/lib/jsonld";

export default function Disclaimer() {
    return (
        <LegalPage
            testId="page-disclaimer"
            title="Disclaimer"
            seo={{
                title: "Disclaimer | Human Design Studio",
                description:
                    "Human Design sessies zijn gericht op zelfinzicht en persoonlijke ontwikkeling, geen medische of therapeutische behandeling.",
                path: "/disclaimer",
                jsonLd: [breadcrumbLd("Disclaimer", "/disclaimer")],
            }}
            sections={[
                {
                    body: [
                        "Human Design en de sessies van Human Design Studio zijn gericht op zelfinzicht en persoonlijke ontwikkeling. Het is geen medische, psychologische of therapeutische behandeling en geen vervanging daarvan.",
                        "Heb je gezondheidsklachten, mentaal of lichamelijk, raadpleeg dan een arts of een bevoegde hulpverlener. Een sessie stelt geen diagnose en belooft geen genezing of specifiek resultaat.",
                        "De informatie op deze website is met zorg samengesteld, maar je blijft zelf verantwoordelijk voor de keuzes die je maakt.",
                    ],
                },
            ]}
        />
    );
}
